import { Side } from './side';
import { HorizontalPosition } from './horizontalPosition';
import { VerticalPosition } from './verticalPosition';


/**
 * Returns whether or not the given side is vertical i.e. top/bottom
 * @param position
 */
export const isVerticalSide = (position: Side): boolean => position === 'top' || position === 'bottom';


/**
 * Returns whether or not the given side is an end side, reading left-to-right, top-to-bottom. This means right/bottom
 * are end sides.
 */
export const isEndSide = (position: Side): boolean => position === 'bottom' || position === 'right';


/**
 * Converts a Side to a horizontal position. top/bottom map to center
 */
export const toHorizPosition = (
  side: Side,
): HorizontalPosition => side === 'left' || side === 'right' ? side : 'center';


/**
 * Converts a Side to a vertical position. left/right map to center
 */
export const toVertPosition = (side: Side): VerticalPosition => {
  switch (side) {
    case 'top':
      return 'above';

    case 'bottom':
      return 'below';

    default:
      return 'center';
  }
};
